module.exports = __webpack_public_path__ + "static/media/Red_sign.af2645b5.png";